export const permissions = {
  facebook: "67489516bc7ca66e163a1869",
  google: "67489561bc7ca66e163a186e",
  pages: "674897ed613e5c5f79a5e57f",
  gallery: "674d9534b9fdf4cc21615dc9",
  notifications: "674d9581b9fdf4cc21615dda",
};
